
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  MenuItem,
  Card,
  CardContent,
  IconButton,
  Autocomplete,
} from "@mui/material";
import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import styles from "../../../styles.module.css";
import {
  Breadcrumb,
  Cancel,
  CTSinput,
} from "../../reusableComponent/Reusables";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonIcon from '@mui/icons-material/Person';
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import customerMasterService from "../../../services/masters/customerMaster.Service";
import industryMasterService from "../../../services/masters/industryMaster.Service";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import accountManagerMasterService from "../../../services/masters/accountManagerMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// ── CSS Styles (same as PlantAdd) ──────────────────────────────────────────

const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Inter', Arial, sans-serif",
};

const breadcrumbSx = {
  fontSize: "12px",
  color: "#718096",
  mb: 2,
  display: "flex",
  alignItems: "center",
  gap: "6px",
};

const pageHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
};

const pageTitleSx = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000000",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const backBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#2B6CB0",
  padding: "7px 14px",
  border: "1.5px solid #2B6CB0",
  borderRadius: "7px",
  background: "#fff",
  cursor: "pointer",
  textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};

const formCardSx = {
  background: "#fff",
 
  border: "1px solid #E2E8F0",
  overflow: "hidden",
  mb: 3,
};

const sectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const sectionHeaderTitleSx = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff",
  letterSpacing: "0.3px",
};

const formBodySx = { padding: "22px 24px" };

const fieldLabelSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#2063b6",
  mb: "4px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa",
    height: "38px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
    "&.Mui-disabled": { background: "#F8FAFC" },
  },
  "& input": {
    color: "#1A202C",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};

const contactSectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  borderTop: "1px solid #E2E8F0",
};

const formFooterSx = {
  padding: "18px 24px",
  background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
};

const saveBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#4CAF50",
  color: "#fff",
  border: "none",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  fontFamily: "'Inter', Arial, sans-serif",
  "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
  "&:active": { transform: "translateY(0)" },
  "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
  transition: "all 0.15s ease",
};

const cancelBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#E53E3E",
  color: "#ffffff",
  border: "none",
  "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
  fontSize: "14px",
  fontWeight: 600,
  borderRadius: "8px",
};

// ─────────────────────────────────────────────────────────────────────────────

const CustomerAdd = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;

  const { handleSubmit, register, formState: { errors } } = useForm();
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;

  const [data, setData] = useState({
    cust_name: editData ? editData.cust_name : "",
    cust_address: editData ? editData.cust_address : "",
    city: editData ? editData.city : "",
    pin: editData ? editData.pin : "",
    state: editData ? editData.state : "",
    tel_no: editData ? editData.tel_no : "",
    gstno: editData ? editData.gstno : "",
    pan_no: editData ? editData.pan_no : "",
    cin: editData ? editData.cin : "",
    sales_officer_id: editData ? editData.sales_officer_id : "",
    industry: editData ? editData.industry : "",
    credit_limit: editData ? editData.credit_limit : "0",
    credit_period: editData ? editData.credit_period : "0",
    joining_dt: editData && editData.joining_dt
      ? dayjs(editData.joining_dt).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD"),
    opening_bal: editData ? editData.opening_bal : "0",
    depot_id: editData ? editData.depot_id : "",
    contact_person: editData ? editData.contact_person : "",
    designation: editData ? editData.designation : "",
    contact_no: editData ? editData.contact_no : "",
    email: editData ? editData.email : "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [selectedState, setSelectedState] = useState(data.state || "");
  const [industry, setIndustry] = useState([]);
  const [depot, setDepot] = useState([]);
  const [account_manager, setAccountManager] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const [industryData, depotData, accountManagerData] = await Promise.all([
          industryMasterService.getIndustryList({ page: 0, size: 10, searchKey: "" }),
          depotMasterService.getDepotList({ page: 0, size: 10, searchKey: "" }),
          accountManagerMasterService.getAccountManagerList({ page: 0, size: 10, searchKey: "" }),
        ]);
        setIndustry(industryData);
        setDepot(depotData);
        setAccountManager(accountManagerData);
      } catch (error) {
        console.error("Data fetching failed", error);
        setSuccessMessage("Error fetching dropdown data");
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (editData) {
      setSelectedState(editData.state);
    }
  }, [editData]);

  const handleChange = ({ target }) => {
    const value = target.value;
    setData((prevData) => ({
      ...prevData,
      [target.name]: value,
    }));
  };

  const handleStateChange = (e) => {
    const state = e.target.value;
    setSelectedState(state);
    handleChange(e);
  };

  const onSubmit = async () => {
    setIsSubmitting(true);
    const customerData = {
      ...data,
      modified_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      modified_by: editData ? userInfo.user_id : null,
      created_at: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      created_by: editData ? editData.created_by : userInfo.user_id,
      changedUpdatedValue: "edit",
      cust_id: editData ? editData.cust_id : null,
    };
    try {
      if (editData) {
        await customerMasterService.editDeleteCustomer(customerData);
        setSuccessMessage("Updated successfully");
      } else {
        await customerMasterService.addCustomer(customerData);
        setSuccessMessage("Added successfully");
      }
      setTimeout(() => navigate(-1), 1000);
    } catch (error) {
      setSuccessMessage("Error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  const indianStates = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
    "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya",
    "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim",
    "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  ];

  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>

        {/* Breadcrumb */}
        <Box sx={breadcrumbSx}>
          <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Customer</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <PersonIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData ? "UPDATE" : "CREATE"} CUSTOMER MASTER
          </Box>
          <Button onClick={handleBack} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        {/* Main Form Card */}
        <Box sx={formCardSx}>
          {/* Navy Strip Header */}
          <Box sx={sectionHeaderSx}>
            <PersonIcon sx={{ fontSize: 18, color: "#fff" }} />
            <Typography sx={sectionHeaderTitleSx}>Customer Information</Typography>
          </Box>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={formBodySx}>
              <Grid container spacing={3}>

                {/* Customer Name */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>
                      Customer Name <span style={{ color: "#E53E3E" }}>*</span>
                    </Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="cust_name"
                      value={data.cust_name} required sx={inputSx}
                      placeholder="Enter customer name"
                    />
                  </Box>
                </Grid>

                {/* Customer Address */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>
                      Customer Address <span style={{ color: "#E53E3E" }}>*</span>
                    </Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="cust_address"
                      value={data.cust_address} required sx={inputSx}
                      placeholder="Enter customer address"
                    />
                  </Box>
                </Grid>

                {/* City */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>
                      City <span style={{ color: "#E53E3E" }}>*</span>
                    </Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="city"
                      value={data.city} required sx={inputSx}
                      placeholder="Enter city"
                    />
                  </Box>
                </Grid>

                {/* State */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>
                      State <span style={{ color: "#E53E3E" }}>*</span>
                    </Typography>
                    <Autocomplete
                      options={indianStates}
                      fullWidth
                      value={data.state || null}
                      onChange={(event, newValue) => {
                        setData({ ...data, state: newValue || "" });
                      }}
                      renderOption={(props, option) => (
                        <MenuItem {...props} sx={{ fontSize: "13px" }}>{option}</MenuItem>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params} size="small" required fullWidth
                          placeholder="Select a state" sx={inputSx}
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option === value}
                    />
                  </Box>
                </Grid>

                {/* PIN */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>
                      PIN <span style={{ color: "#E53E3E" }}>*</span>
                    </Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="pin"
                      value={data.pin} required sx={inputSx}
                      placeholder="Enter PIN code"
                    />
                  </Box>
                </Grid>

                {/* GST No */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>
                      GST No <span style={{ color: "#E53E3E" }}>*</span>
                    </Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="gstno"
                      value={data.gstno} required sx={inputSx}
                      placeholder="Enter GST number"
                    />
                  </Box>
                </Grid>

                {/* PAN No */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>
                      PAN No <span style={{ color: "#E53E3E" }}>*</span>
                    </Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="pan_no"
                      value={data.pan_no} required sx={inputSx}
                      placeholder="Enter PAN number"
                    />
                  </Box>
                </Grid>

                {/* CIN */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>
                      CIN <span style={{ color: "#E53E3E" }}>*</span>
                    </Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="cin"
                      value={data.cin} required sx={inputSx}
                      placeholder="Enter CIN"
                    />
                  </Box>
                </Grid>

                {/* Industry */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>
                      Industry <span style={{ color: "#E53E3E" }}>*</span>
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Autocomplete
                        options={industry || []}
                        fullWidth
                        getOptionLabel={(option) => option?.industry_name || ""}
                        value={industry?.find((item) => String(item.industry_id) === String(data.industry)) || null}
                        onChange={(event, newValue) => {
                          setData({ ...data, industry: newValue ? String(newValue.industry_id) : "" });
                        }}
                        renderOption={(props, option) => (
                          <MenuItem {...props} sx={{ fontSize: "13px" }}>{option.industry_name}</MenuItem>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params} size="small" required fullWidth
                            placeholder="Select industry" sx={inputSx}
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          String(option.industry_id) === String(value.industry_id)
                        }
                      />
                      <IconButton
                        onClick={() => handleNavigate('/masters/add-industry')}
                        size="small"
                        sx={{ color: "#2B6CB0", border: "1px solid #2B6CB0", borderRadius: "6px", p: "5px" }}
                      >
                        <AddIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                </Grid>

                {/* Credit Limit */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>
                      Credit Limit (INR) <span style={{ color: "#E53E3E" }}>*</span>
                    </Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="credit_limit"
                      value={data.credit_limit} sx={inputSx}
                      placeholder="Enter credit limit"
                    />
                  </Box>
                </Grid>

                {/* Credit Period */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Credit Period (days)</Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="credit_period"
                      value={data.credit_period} sx={inputSx}
                      placeholder="Enter credit period"
                    />
                  </Box>
                </Grid>

                {/* Joining Date */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Joining Date</Typography>
                    <DatePicker
                      format="DD/MM/YYYY"
                      value={data.joining_dt ? dayjs(data.joining_dt) : dayjs()}
                      onChange={(newValue) =>
                        handleChange({
                          target: {
                            name: "joining_dt",
                            value: newValue ? newValue.format("YYYY-MM-DD") : "",
                          },
                        })
                      }
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          sx: inputSx,
                          placeholder: "Select joining date",
                        },
                      }}
                    />
                  </Box>
                </Grid>

                {/* Opening Balance */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Opening Balance</Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="opening_bal"
                      value={data.opening_bal} sx={inputSx}
                      placeholder="Enter opening balance"
                    />
                  </Box>
                </Grid>

                {/* Tel No */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Tel No</Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="tel_no"
                      value={data.tel_no} sx={inputSx}
                      placeholder="Enter telephone number"
                    />
                  </Box>
                </Grid>

                {/* Depot */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>
                      Depot <span style={{ color: "#E53E3E" }}>*</span>
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Autocomplete
                        options={depot || []}
                        fullWidth
                        getOptionLabel={(option) => option?.depot_name || ""}
                        value={depot?.find((item) => String(item.depot_id) === String(data.depot_id)) || null}
                        onChange={(event, newValue) => {
                          setData({ ...data, depot_id: newValue ? String(newValue.depot_id) : "" });
                        }}
                        renderOption={(props, option) => (
                          <MenuItem {...props} sx={{ fontSize: "13px" }}>{option.depot_name}</MenuItem>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params} size="small" required fullWidth
                            placeholder="Select depot" sx={inputSx}
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          String(option.depot_id) === String(value.depot_id)
                        }
                      />
                      <IconButton
                        onClick={() => handleNavigate('/masters/add-depot')}
                        size="small"
                        sx={{ color: "#2B6CB0", border: "1px solid #2B6CB0", borderRadius: "6px", p: "5px" }}
                      >
                        <AddIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </Box>
                </Grid>

              </Grid>
            </Box>

            {/* Contact Information Section */}
            <Box sx={contactSectionHeaderSx}>
              <PersonIcon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionHeaderTitleSx}>Contact Information</Typography>
            </Box>

            <Box sx={formBodySx}>
              <Grid container spacing={3}>

                {/* Contact Person */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Contact Person</Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="contact_person"
                      value={data.contact_person} sx={inputSx}
                      placeholder="Enter contact person name"
                    />
                  </Box>
                </Grid>

                {/* Designation */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Designation</Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="designation"
                      value={data.designation} sx={inputSx}
                      placeholder="Enter designation"
                    />
                  </Box>
                </Grid>

                {/* Contact No */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Contact No</Typography>
                    <TextField
                      size="small" fullWidth type="text"
                      onChange={handleChange} name="contact_no"
                      value={data.contact_no} sx={inputSx}
                      placeholder="Enter contact number"
                    />
                  </Box>
                </Grid>

                {/* Email */}
                <Grid item xs={12} md={6}>
                  <Box>
                    <Typography sx={fieldLabelSx}>Email</Typography>
                    <TextField
                      size="small" fullWidth type="email"
                      onChange={handleChange} name="email"
                      value={data.email} sx={inputSx}
                      placeholder="Enter email address"
                    />
                  </Box>
                </Grid>

              </Grid>
            </Box>

            {/* Form Footer */}
            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={handleBack}>
                Cancel
              </Button>
              <Button type="submit" sx={saveBtnSx} disabled={isSubmitting}>
                <SaveIcon sx={{ fontSize: 18 }} />
                {editData ? "Update" : "Save"}
              </Button>
            </Box>
          </form>
        </Box>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') setSuccessMessage("");
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </LocalizationProvider>
  );
};

export default CustomerAdd;